/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {ETrackedItemTypes} from "../../../../constants/trackedItems";

// TODO: Don't have non-unique exports (check everywhere).
const FAVORITE_TYPE = ETrackedItemTypes.LIDAR_CONFIGURATION

const INNERVTAB_URL_PARAM = 'innervtabs-1'
const FAVORITE_PARAM_ID = INNERVTAB_URL_PARAM
const TRACKED_ITEM_LABEL_PREFIX = "Lidar"

export interface LidarPropertiesTableRow {
  propertyName: string
  propertyValue: string
  unit: string
}
export interface LidarPropertiesObject{
  key: string
  label: string
  unit: string
}

export const LidarPropsKeyToTitleMap: LidarPropertiesObject[] = [

  {
    key: "azimuthFOV",
    label: "Instrumentation Azimuth Limit",
    unit: "deg"
  },
  {
    key: "elevationFOV",
    label: "Instrumentation Elevation Limit",
    unit: "deg"
  },
  {
    key: "maxInstrumentedRange",
    label: "Instrumentation Range Limit",
    unit: "m"
  },
]

export const fovAndBoresightLidarKeyToLabelMap: LidarPropertiesObject[] = [
  {
    key: "azimuth_fov",
    label: "Azimuth FOV",
    unit: "deg"
  },
  {
    key: "elevation_fov",
    label: "Elevation FOV",
    unit: "deg"
  },
  {
    key: "max_range",
    label: "Max Det. Range at Boresight",
    unit: "m"
  }
]

export interface ObjectPropertiesInput{
  key: string
  label: string
  unit: string
  isDropDown?: boolean
}

export interface ObjectPropertyRow{
  objectPropertyName: string
  objectPropertyValue: string
  objectPropertyKey: string
}

export const objectPropertiesInput: ObjectPropertiesInput[] = [
  {
    key: "objectCategory",
    label: "Object Category",
    unit: ""
  },
  {
    key: "objectName",
    label: "Object Name",
    unit: ""
  },
  {
    key: "objectVersion",
    label: "Object Version",
    unit: ""
  },
  {
    key: "objectProperties",
    label: "Object Variants",
    isDropDown: true,
    unit: ""
  },
  {
    key: "temperature",
    label: "Temperature",
    unit: "°C"
  },
  {
    key: "pointsFrames",
    label: "Points Frames",
    unit: ""
  },
]
// Column names for the Blueline export
export const COLUMN_NAMES = {
  AZIMUTH_ANGLE: "Azimuth Angle (deg)",
  DISTANCE: "Distance (m)",
}
export {
  FAVORITE_TYPE,
  INNERVTAB_URL_PARAM,
  FAVORITE_PARAM_ID,
  TRACKED_ITEM_LABEL_PREFIX
}